import { Component, OnInit } from '@angular/core';

import { AccountService } from '../../_services/account.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  accountList: any = [];
  profileInfo: any = [];
  capabilityInfo: any = [];

  constructor(
    private account: AccountService,
    private tokenStorage: TokenStorageService,
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    
    this.account.getAccountsList$(contactUUID).subscribe({
      next: data => {
        this.accountList = data;
        console.log('this.accountList', this.accountList);

        for (let i = 0; i < this.accountList.length; i++) {
          let profileId = this.accountList[i].account_id;
          console.log('this.accountList[i]', this.accountList[i]);
        
     
          
          //make a list with inactive profiles elsewhere
          
          this.account.getAccountProfile$(profileId, contactUUID).subscribe((profile: any) => {
                this.accountList[i].account_id = profile.account_id;
                this.accountList[i].email = profile.email;
                this.accountList[i].first_name = profile.first_name;
                this.accountList[i].last_name = profile.last_name;
                this.accountList[i].capability = profile.profile_id;
                this.accountList[i].active = profile.active;
      
           });


          //console.log(this.accountList);

          this.account.getAccountCapabilities$(profileId, contactUUID).subscribe((capabilities: any) => {
            let capability = capabilities;
            this.accountList[i].capability_name = capability[0]?.name;
          })
        }
      }
    });
  }
}